"use client"

import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon } from "lucide-react"
import PropTypes from "prop-types"

function Checkbox({ style, ...props }) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      {...props}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "20px",
        height: "20px",
        borderRadius: "4px",
        border: "2px solid #ccc",
        backgroundColor: "#fff",
        cursor: props.disabled ? "not-allowed" : "pointer",
        ...style,
      }}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#2563eb", // blue check color
        }}
      >
        <CheckIcon style={{ width: "16px", height: "16px" }} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

Checkbox.propTypes = {
  style: PropTypes.object,
  disabled: PropTypes.bool,
}

export { Checkbox }
